import { render, staticRenderFns } from "./EditArticleLoader.vue?vue&type=template&id=13958c26"
import script from "./EditArticleLoader.vue?vue&type=script&lang=ts"
export * from "./EditArticleLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports